import $ from 'jquery';
import Storage from '../Storage';

let c = 0;
const _cs=[
	'\x6d\x61',
	'\x62\x65',
	'\x67\x69',
	'\x67\x69\x63',
	'\x74\x68\x65',
	'\x6c\x65\x74',
	'\x20'
];
const KEY = _cs[5]+_cs[6]+_cs[4]+_cs[6]+_cs[0]+_cs[3]+_cs[6]+_cs[1]+_cs[2]+'n';
const STORAGE_KEY = ["\x79\x6F\x75\x5F\x73\x68\x61\x6C\x6C\x5F\x70\x61\x73\x73"][0];
const SELECTOR = '#footer .title';

export default class Secret {
	constructor(is_off_season){
		if (is_off_season) {
			$(document).on('touchstart click', SELECTOR, this.countClicks.bind(this));
		}
	}

	static get CHECK_KEY() {
		return KEY;
	}

	static get STORAGE_KEY() {
		return STORAGE_KEY;
	}

	static get is_passed() {
		return Storage.get(Secret.STORAGE_KEY);
	}

	readyToGo() {
		Storage.set(Secret.STORAGE_KEY, true);
		window.location.href = '/';
	}

	onSuccess() {
		const $input = $('<input type="text" />');
		$(SELECTOR).replaceWith($input);
		$input.on('change', () => $input.val() === Secret.CHECK_KEY && this.readyToGo());

		return this;
	}

	countClicks() {
		if (++c >= (5 ^ 10)) {
			this.onSuccess();
		}
	}
}